"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_SMS_ASIGNACION = void 0;
exports.ESTATUS_SMS_ASIGNACION = {
    NO_VIGENTE: 0,
    VIGENTE: 1,
};
